import React from 'react';

import FormSection from 'containers/FormSectionContainer';
import FieldSet from 'containers/FieldSetContainer';
import FormField from 'containers/FormField';
import ConditionalSection from 'containers/ConditionalSection';
import RadioButtonGroup from 'components/RadioButtonGroup';
import CheckboxGroup from 'components/CheckboxGroup';
import Datepicker from 'components/Datepicker';
import TextFieldBox from 'components/TextFieldBox';

import { has, fieldIs } from 'lib/conditions';

import FormProvider from 'routes/Documents/containers/FormProvider';
import TextFieldArea from 'components/TextFieldArea';
import { dateFromPartial, isPartialDate, partialDateFromDate } from 'neuro-utils';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

const formatOpt = opt => `relapse.opts.${opt}`;

const RelapseForm = props => {
  const formSettings = props.formSettings;
  const language = props.lang ?? 'fi';

  return (
    <FormProvider {...props}>
      <FormSection localeId="dictionary.date">
        <FieldSet localeId="dictionary.startDate">
          <FormField
            name="relapseDate"
            component={props => (
              <Datepicker
                {...props}
                input={{
                  ...props.input,
                  value: isPartialDate(props.input.value) ? dateFromPartial(props.input.value) : props.input.value,
                  onChange: date => props.input.onChange(partialDateFromDate(new Date(date))),
                }}
              />
            )}
          />
        </FieldSet>
      </FormSection>

      <FormSection localeId="relapse.labels.symptoms">
        <FieldSet localeId="dictionary.chooseOneOrMore">
          <FormField
            name="relapseSymptoms"
            component={CheckboxGroup}
            optionFormatter={formatOpt}
            options={[
              { value: 'difficultiesInvolvedInTheMovement' },
              { value: 'dizziness' },
              { value: 'balanceDisorders' },
              { value: 'muscularDebility' },
              { value: 'muscleTension' },
              { value: 'visualDisturbances' },
              { value: 'doubleVision' },
              { value: 'tremor' },
              { value: 'pain' },
              { value: 'theLackOfCoordination' },
              { value: 'faceTouchAndPain' },
              { value: 'sensoryDysfunctionNumbnessTingling' },
              { value: 'bladderOrBowelProblemsRelatingToTheOperation' },
              { value: 'problemsWithTheIdeaOftheAction' },
              { value: 'exceptionalFatigue' },
              { value: 'depression' },
              { value: 'powerlessness' },
              { value: 'other' },
            ]}
          />
        </FieldSet>

        <ConditionalSection condition={has('relapseSymptoms', 'other')}>
          <FieldSet localeId="dictionary.otherWhat">
            <FormField name="relapseSymptomsOther" component={TextFieldBox} hintLocale="dictionary.otherWhat" />
          </FieldSet>
        </ConditionalSection>
      </FormSection>

      <FormSection localeId="relapse.labels.symptomDetails">
        <FieldSet localeId="relapse.labels.symptomDetailsText">
          <FormField
            name="symptomDetails"
            component={TextFieldArea}
            fullWidth
            rows={5}
            viewStyle={{ width: '30rem' }}
            hintLocale="relapse.labels.symptomDetailsTextPlaceholder"
          />
        </FieldSet>
        <FieldSet localeId="relapse.labels.acuteSymptoms">
          <FormField name="acuteSymptoms" component={RadioButtonGroup} preset="yesno" />
        </FieldSet>
        <ConditionalSection condition={fieldIs('acuteSymptoms', 'yes')}>
          <div style={{ maxWidth: '80rem', marginBottom: '2rem' }}>
            {formSettings?.localizations?.acuteSymptomsInfoScreen?.[language] ?? (
              <FormattedMessage id="relapse.acuteSymptomsInfoText" />
            )}
          </div>
        </ConditionalSection>
        <FieldSet localeId="relapse.labels.feverOrInfection">
          <FormField name="feverOrInfection" component={RadioButtonGroup} preset="yesno" />
        </FieldSet>
        <ConditionalSection condition={fieldIs('feverOrInfection', 'yes')}>
          <div style={{ maxWidth: '80rem', marginBottom: '2rem' }}>
            {formSettings?.localizations?.feverOrInfectionInfoScreen?.[language] ?? (
              <FormattedMessage id="relapse.feverOrInfectionInfoText" />
            )}
          </div>
        </ConditionalSection>
        <FieldSet localeId="relapse.labels.lessThanOneMonthSinceLastRelapse">
          <FormField name="lessThanOneMonthSinceLastRelapse" component={RadioButtonGroup} preset="yesno" />
        </FieldSet>
      </FormSection>
    </FormProvider>
  );
};

const mapStateToProps = (state, props) => {
  return { ...props, lang: state.session.lang };
};

export default connect(mapStateToProps)(RelapseForm);
